import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NotebookState } from '@mode/notebooks/contract';

@Component({
  selector: 'mode-status-bar',
  templateUrl: './notebook-status-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotebookStatusBarComponent {
  @Input() state!: NotebookState;

  public readonly NotebookState = NotebookState;

  get shouldShowBanner(): boolean {
    return this.state !== NotebookState.Ready && this.state !== NotebookState.Success;
  }

  get shouldShowLoader(): boolean {
    return (
      this.state === NotebookState.Loading ||
      this.state === NotebookState.Running ||
      this.state === NotebookState.Session ||
      this.state === NotebookState.Busy
    );
  }

  get shouldShowIcon(): boolean {
    return this.shouldShowBanner && !this.shouldShowLoader;
  }

  get warningState(): boolean {
    return (
      this.state === NotebookState.Warning ||
      this.state === NotebookState.Error ||
      this.state === NotebookState.Cancelled ||
      this.state === NotebookState.Cancelling
    );
  }

  get statusType(): 'info' | 'warning' | null {
    return this.warningState ? 'warning' : this.shouldShowBanner ? 'info' : null;
  }
}
